import { ORDER_TYPE_PICKUP_AT_WARECLOUD } from '../config/consts/orders';

export const sortMaxOrderNewClouder = (arr) =>
  [...arr].sort(
    (a, b) =>
      (b.n_orders < ORDER_TYPE_PICKUP_AT_WARECLOUD) -
        (a.n_orders < ORDER_TYPE_PICKUP_AT_WARECLOUD) || a.n_orders - b.n_orders
  );
